/* eslint-disable @typescript-eslint/no-explicit-any */
import { ConfigurationService } from '@interacta-shared/data-access-configuration';
import { toPaginatedList } from '@interacta-shared/util';
import { toAuthUser } from '@interacta-shared/util-common';
import { NotificationEvent, NotificationsStream } from './notification.model';

export type NotificationEventDeserializeFn = (
    record: any,
    configService: ConfigurationService,
) => Pick<NotificationEvent, 'routerLink'>;

export const toNotificationsStream = (
    record: any,
    configService: ConfigurationService,
    deserializeFn: NotificationEventDeserializeFn,
): NotificationsStream => ({
    notifications: toPaginatedList(record, (item) =>
        toNotificationEvent(item, configService, deserializeFn),
    ),
    nextSyncToken: record.nextSyncToken,
});
export const toNotificationEvent = (
    record: any,
    configService: ConfigurationService,
    deserializeFn: NotificationEventDeserializeFn,
): NotificationEvent => ({
    id: record.id,
    typeId: record.typeId,
    authorUsers: record.authorUser
        ? [toAuthUser(record.authorUser)]
        : record.authorUsers
          ? record.authorUsers.map(toAuthUser)
          : [],
    read: record.read,
    timestamp: new Date(record.timestamp as number),
    aggregated: record.aggregated ?? false,
    aggregatedNotificationIds: record.aggregatedNotificationIds,
    title: record.title,
    descriptionPlainText: record.descriptionPlainText,
    pushEnabled: record.pushEnabled ?? true,
    ...deserializeFn(record, configService),
});
